import { VirtualAssistantRepository } from '@/components/virtual-assistant/virtual-assistant.repository';
import { tryCatch } from '@/redux/thunks/shared/try-catch';
import { AjaxService } from '@/services';
import { API_URL, getApiUrl } from '@/utils/api';

export class HttpVirtualAssistantRepository implements VirtualAssistantRepository {
	private readonly baseUrl: string;

	constructor(private ajaxService = new AjaxService()) {
		this.baseUrl = getApiUrl(API_URL.PRODUCT);
	}

	async submit(
		request: string,
		init: boolean = false,
		sessionId: string,
		actorId: string,
		storeId: string,
		contentId: string | null,
		pageType: string | null,
	) {
		const { data, error } = await tryCatch(
			this.ajaxService.postPromisedJSON(`${this.baseUrl}/api/sommelier/chat-millesimmelier`, {
				prompt: request,
				sessionId,
				init,
				storeId,
				contentId,
				pageType,
			}),
		);

		if (error) {
			return null;
		}

		return data;
	}
}
